import Colors from "styles/colors";
export default {
    name: "Jeff E.",
    jobDescription: "Software Application Specialist Mechanical or Industrial Engineering",
    color: Colors["white"]
};
